import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['One brand, one model, one symptom at a time', 'Error codes with no path from the code to the cause', 'No way to tell a bad part from a dirty one', 'Generic HVAC forms with nothing for ice: no sanitation log, no ice-quality check', 'Every call starts from zero again'];
const withIt = ['The Freeze-or-Harvest Split on every call, any brand', 'Symptom-to-part flowcharts for no ice, bad ice, harvest and leaks', 'Prove-It-Twice tests before a part leaves the van', 'Sanitation logs, PM checklists, reports and repair-vs-replace ready', 'The same one-page layout across 124 procedures'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="grid-light w-full bg-paper" data-id="element-393" data-mp="2d7hng4w7ugi2">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" data-id="element-394" data-mp="30y4vqra1n855">
        <div className="text-center" data-id="element-395" data-mp="30wk5hduribd3">
          <p className="eyebrow text-ember-deep" data-id="element-396" data-mp="35pda81q8djp6">
            Why this isn&apos;t another code table
          </p>
          <h2 id="vs-heading" className="rule-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-397" data-mp="1tg4uqfp8fnpm">
            Scattered tips vs{' '}
            <span className="text-sys-refrig" data-id="element-398" data-mp="236r2jnqpj9xr">a field system</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-399" data-mp="1ydeqed37svlw">
            Yes, parts sites and manufacturers post troubleshooting tips and
            error codes for free. Finding a code was never the hard part —
            knowing which system failed, proving the part and closing the call
            with clean paperwork is. That’s the part this does for you.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-paper-dark shadow-card" data-id="element-400" data-mp="2h5z1qgmvei1y">
          <div className="bg-signal px-3.5 py-4 text-white sm:p-6" data-id="element-401" data-mp="rqj7e7dlv0w4">
            <span className="font-display text-2xl uppercase leading-none sm:text-3xl" data-id="element-402" data-mp="mrptweybj9vy">
              Tips
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-white/85 sm:text-[11px]" data-id="element-403" data-mp="2muqokidbbpqe">
              Parts sites &amp; forums
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-404" data-mp="2vtcewzp1091q">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-white/95 sm:text-sm" data-id="element-405" data-mp="30soy9agouxzk">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-406" data-mp="35q7d1hhe07fh">
                    <XIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-407" data-mp="3fi3cowz4g5lt" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-forest-deep px-3.5 py-4 text-white sm:p-6" data-id="element-408" data-mp="3oirpxpgoy1xn">
            <span className="font-display text-2xl uppercase leading-none sm:text-3xl" data-id="element-409" data-mp="3ogf1qukcavc5">
              System
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-ember sm:text-[11px]" data-id="element-410" data-mp="7fvp04x797m2">
              Ice Machine Diagnostic Pro
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-411" data-mp="2j585fdkm7zl">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-medium leading-snug sm:text-sm" data-id="element-412" data-mp="3tnn6u8f03aoq">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-sky" data-id="element-413" data-mp="q5lf4eq0p57n">
                    <CheckIcon className="h-2.5 w-2.5 text-pine" aria-hidden="true" data-id="element-414" data-mp="l8v3q4p5qxsk" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}